<div class="bg-white border-top-0 fixed-top card-border position-static">
  <div class="">
    <div class="header-classic ">
      <div class="top-header bg-color1">
        <div class="container">
          <div class="row d-flex justify-content-between">
            <div class="col-lg-6 pt-2">
              <span class="text-light ">Life is Happy when you are Healthy!</span>
            </div>
            <div class="col-lg-6 pt-0 pt-md-2 pb-0 pb-md-2">
              <div class="d-flex  justify-content-start justify-content-lg-end ml-0 ml-md-1">
                <div class="">
                  <ul class="list-unstyled ">
                    <li class="text-light ml-2"><i class="fa fa-phone fa-fw  font-size-16 text-light cursor"></i><span
                        class="cursor">Call Us :
                        (44) 495 060 77</span>
                    </li>
                    <li class="text-light"><i
                        class="fa fa-comments fa-envelope ml-0 ml-md-2 mr-1 font-size-16 text-light cursor"></i> <a
                        href="mailto:stayhealthy@sooperdr.io" class="text-light">Mail us:
                        support@reliabledrs.com</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container pt-2 pb-2">
        <div class="row">
          <div class="col-lg-12 pl-0 pr-0">
            <nav class="navbar navbar-expand-lg navbar-classic ">
              <a href="{{homePageUrl}}" class="navbar-brand d-inline-block pt-0"> <img src="/assets/images/logo1.svg"
                  class="w-230px"></a>
              <button class="navbar-toggler collapsed" type="button" data-toggle="collapse"
                data-target="#navbar-classic" aria-controls="navbar-classic" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="icon-bar top-bar mt-0"></span>
                <span class="icon-bar middle-bar"></span>
                <span class="icon-bar bottom-bar"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbar-classic">
                <ul class="navbar-nav  mt-2 mt-lg-0 mr-xl-3 ml-xl-4">
                  <li class="nav-item" *ngIf="patientRoutes"><a
                      class="nav-link pl-3 pl-md-4 text-uppercase  font-size-15 font-weight-500 link-hover"
                      routerLink="/patient/members" routerLinkActive="active">home</a>
                  </li>
                  <li class="nav-item" *ngIf="!patientRoutes"><a
                      class="nav-link pl-3 pl-md-4 text-uppercase  font-size-15 font-weight-500 link-hover"
                      href="{{homePageUrl}}">home</a>
                  </li>
                  <li class="nav-item" *ngIf="patientRoutes"><a
                      class="nav-link pl-3 text-uppercase  font-size-15 font-weight-500 link-hover"
                      routerLink="/patient/account" routerLinkActive="active">MY ACCOUNT</a>
                  </li>
                  <div class="dropdown" *ngIf="!patientRoutes">
                    <li class="nav-item"><a
                        class="nav-link text-uppercase pl-3 link-hover  font-size-15 font-weight-500"
                        href="contact-us.html" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">About us</a></li>
                    <div class="dropdown-menu w-250px p-2" aria-labelledby="dropdownMenuButton">
                      <a href="{{whoWeUrl}}" class="dropdown-item mt-2">WHO
                        WE ARE
                      </a>
                      <a href="{{ourTeamUrl}}" class="dropdown-item mt-2 mb-2">OUR TEAM</a>
                    </div>
                  </div>
                  <li class="nav-item"><a class="nav-link pl-3 link-hover text-uppercase  font-size-15 font-weight-500"
                      href="contact-us.html" routerLink="/physician/search" routerLinkActive="active">Find doctor</a>
                  </li>
                  <div class="dropdown" *ngIf="!patientRoutes">
                    <li class="nav-item"><a
                        class="nav-link pl-3 link-hover text-uppercase  font-size-15 font-weight-500"
                        href="contact-us.html" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">Appointments</a></li>
                    <div class="dropdown-menu p-2 w-250px p-2" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item mt-2" href="#" routerLink="/search/appointment"
                        routerLinkActive="active">SEARCH APPOINTMENT
                      </a>
                      <a class="dropdown-item mt-2 mb-2" href="{{faqUrl}}">FAQ</a>
                    </div>
                  </div>
                  <li class="nav-item" *ngIf="patientRoutes"><a
                      class="nav-link pl-3 text-uppercase  font-size-15 font-weight-500 link-hover"
                      routerLinkActive="active" routerLink="/patient/appointments"> MY APPOINTMENTS</a>
                  </li>
                  <li class="nav-item" *ngIf="patientRoutes"><a
                      class="nav-link pl-3 text-uppercase  font-size-15 font-weight-500 link-hover"
                      routerLinkActive="active" routerLink="/patient/organisation"> My Organization</a>
                  </li>
                  <li class="nav-item" *ngIf="!patientRoutes"><a
                      class="nav-link pl-3 link-hover text-uppercase font-size-15 font-weight-500"
                      href="{{blogUrl}}">Blog</a>
                  </li>
                  <li class="nav-item" *ngIf="!patientRoutes"><a
                      class="nav-link pl-3 link-hover text-uppercase font-size-15 font-weight-500"
                      href="{{contactUsUrl}}">contact us</a>
                  </li>
                </ul>
                <!-- <a class="btn btn btn-outline-primary btn-rounded ml-auto">LOGIN/SIGNUP</a> -->

                <a class="btn btn btn-brand pl-3 pr-3 pt-2 pb-2 text-light btn-rounded ml-auto cursor-pointer font-size-14"
                  routerLink="/register" routerLinkActive="active" *ngIf="!patientRoutes">SIGNUP</a>
                <a class="btn btn btn-brand pl-3 pr-3 pt-2 pb-2 text-light btn-rounded ml-3 cursor-pointer font-size-14"
                  routerLink="/login" routerLinkActive="active" *ngIf="!patientRoutes">LOGIN</a>
                <a class="btn btn-primary pl-4 pr-4 pt-2 pb-2 text-light btn-rounded ml-3 cursor-pointer font-size-14"
                  (click)="logout()" *ngIf="patientRoutes">SIGN OUT</a>

              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>